<div class="container-fluid section-card form p-0">
  <div class="text-left pt-3 ps-3">
    <h3 class="profile-title">Colaboradores</h3>
    <span class="sub-title">Estos son los colaboradores del prestador</span>
  </div>
  <div class="table-container scrollable-content text-left mt-3">
    <div class="line mt-2"></div>
    @if (!supplerAssistList) {
      <div class="loader"></div>
    }
    @if (supplerAssistList) {
      <table class="table">
        <thead>
          <tr>
            <th class="ps-3">Nombre</th>
            <th>Fecha de nacimiento</th>
            <th>DNI</th>
            <th>Teléfono</th>
            <th>Estado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (assist of supplerAssistList; track assist) {
            <tr>
              <td class="ps-3">{{ assist.fullName }}</td>
              <td>{{ assist.birthDate | date : "dd/MM/yyyy" }}</td>
              <td>{{ assist.dni }}</td>
              <td>
                {{ assist.phoneNumber.countryCode }}
                {{ assist.phoneNumber.number }}
              </td>
              <td>
                <button
                  type="button"
                  class="cursor-pointer scr-status"
                  [ngClass]="assist.isActive ? 'scr-status--success' : 'scr-status--neutral'"
                  [attr.aria-label]="assist.isActive ? 'Activo. Desactivar colaborador' : 'Inactivo. Activar colaborador'"
                  (click)="activateDeactivate(assist)"
                  >
                  {{ assist.isActive ? "Activo" : "Inactivo" }}
                </button>
              </td>
              <td>
                <app-icon-menu-button [menu]="menu" label="Acciones del colaborador"></app-icon-menu-button>
              </td>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="editAssistant(assist)">
                  Editar
                </button>
                <button mat-menu-item (click)="deleteAssistant(assist)">
                  Eliminar
                </button>
              </mat-menu>
            </tr>
          }
        </tbody>
      </table>
      @if (assistantsLoaded && supplerAssistList.length === 0) {
        <p class="empty-message">Todavía no tiene colaboradores cargados.</p>
      }
    }
  </div>
  <div class="footer d-flex justify-content-end">
    <button
      id="addButton"
      class="mt-1 mb-3 me-3"
      (click)="openAssistantForm()"
      [disabled]="!usrSvc.hasPermission('add:contractor')"
      >
      Agregar colaborador
    </button>
  </div>
  <div
    class="assistants-modal d-flex align-items-center justify-content-center w-100"
    [ngClass]="{ expanded: showAssistantForm }"
    >
    @if (showAssistantForm) {
      <div class="modal-container">
        <div class="form-container h-100 mt-4 pb-3 ms-auto me-auto">
          <div class="row">
            <h2 class="pt-4 ms-4">
              {{ supplierAssistantToEdit ? "Editar" : "Registrar" }} Colaborador
            </h2>
          </div>
          <div class="line"></div>
          <form
            [formGroup]="supplierAssistantForm"
            class="px-4"
            autocomplete="off"
            >
            <div class="mb-4 pt-4">
              <span>{{
                supplierAssistantToEdit
                ? "Edita los datos del colaborador seleccionado"
                : "Ingrese los datos del colaborador"
              }}</span>
            </div>
            <div class="row mx-0 my-3">
              <label class="ps-0 pb-2" for="fullName">Nombre</label>
              <input
                matInput
                name="fullName"
                formControlName="fullName"
                required
                maxlength="50"
              [class]="{
                error:
                  supplierAssistantForm.get('fullName')?.touched &&
                  supplierAssistantForm.get('fullName')?.hasError('required')
              }"
                />
              @if (supplierAssistantForm.get('fullName')?.touched && supplierAssistantForm.get('fullName')?.hasError('required')) {
                <mat-error>Campo obligatorio.</mat-error>
              }
                @if (supplierAssistantForm.get('fullName')?.hasError('pattern')) {
                  <mat-error
                    >
                    El nombre no puede contener números, más de 50 caracteres o
                    caracteres especiales.
                  </mat-error>
                }
              </div>
              <div class="row mx-0 my-3 date-container">
                <label class="ps-0 pb-2" for="birthDate">Fecha de nacimiento</label>
                <input
                  matInput
                  class="date ps-2"
                  type="text"
                  [matDatepicker]="picker"
                  name="birthDate"
                  formControlName="birthDate"
                  required
                  [max]="maxDate"
                  (click)="picker.open()"
              [class]="{
                error:
                  supplierAssistantForm.get('birthDate')?.touched &&
                  supplierAssistantForm.get('birthDate')?.hasError('required')
              }"
                  />
                  <mat-datepicker-toggle
                    class="calendar-icon"
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
              @if (supplierAssistantForm.get('birthDate')?.touched && supplierAssistantForm.get('birthDate')?.hasError('required')) {
                <mat-error>Campo obligatorio.</mat-error>
              }
                </div>
                <div class="row mx-0 my-3">
                  <label class="ps-0 pb-2" for="dni">DNI</label>
                  <input
                    matInput
                    onKeyPress="if(this.value.length==8) return false;"
                    name="dni"
                    formControlName="dni"
                    required
              [class]="{
                error:
                  supplierAssistantForm.get('dni')?.touched &&
                  supplierAssistantForm.get('dni')?.hasError('required')
              }"
                    />
              @if (supplierAssistantForm.get('dni')?.touched && supplierAssistantForm.get('dni')?.hasError('required')) {
                <mat-error>Campo obligatorio.</mat-error>
              }
                    @if (supplierAssistantForm.get('dni')?.hasError('pattern')) {
                      <mat-error
                        >
                        El DNI no puede contener más de 8 dígitos ni menos de 7, tampoco
                        puede contener letras o caracteres especiales.
                      </mat-error>
                    }
                  </div>
                  <div class="row mx-0 my-3" formGroupName="phoneNumber">
                    <div class="row m-0 p-0">
                      <div class="col-2 ps-0">
                        <label class="ps-0 pb-2" for="countryCode">País</label>
                        <div>
                          <mat-select
                            #matSelect
                            required
                            [(value)]="selectedCode"
                            formControlName="countryCode"
                            (selectionChange)="changeSelection(selectedCode)"
                            >
                            <mat-select-trigger>
                              <img class="flag" src="{{ selectedflag }}" alt="" />
                            </mat-select-trigger>
                            @for (code of countryCodesList; track code) {
                              <mat-option
                                [value]="code.countryCode"
                                >
                                <img
                                  with="10px"
                                  height="10px"
                                  src="{{ code.src }}"
                                  alt=""
                                  />
                                </mat-option>
                              }
                            </mat-select>
                          </div>
                        </div>
                        <div class="col-10 pe-0">
                          <label class="ps-0 pb-2" for="number">Teléfono</label>
                          <div>
                            <input
                              class="w-100"
                              matInput
                              type="number"
                              onKeyPress="if(this.value.length==10) return false;"
                              name="number"
                              formControlName="number"
                    [class]="{
                      error:
                        supplierAssistantForm.get('phoneNumber')?.get('number')
                          ?.touched &&
                        supplierAssistantForm
                          .get('phoneNumber')
                          ?.get('number')
                          ?.hasError('required')
                    }"
                              />
              @if (supplierAssistantForm.get('phoneNumber')?.get('number')?.touched && supplierAssistantForm.get('phoneNumber')?.get('number')?.hasError('required')) {
                <mat-error>Campo obligatorio.</mat-error>
              }
                              @if (
                                supplierAssistantForm
                                .get('phoneNumber')
                                ?.get('number')
                                ?.hasError('pattern')
                                ) {
                                <mat-error
                                  >
                                  El teléfono no puede contener ni más ni menos de 10 dígitos,
                                  tampoco puede contener letras o caracteres especiales.
                                </mat-error>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div class="line"></div>
                    <div class="row buttons-footer justify-content-end me-4">
                      <button
                        class="ind-button-lite float-right"
                        (click)="closeAssistanForm()"
                        style="width: 100px !important"
                        >
                        <span>Cancelar</span>
                      </button>
                      <button
                        class="ind-button float-right"
                        type="button"
                        (click)="onSubmit()"
                        >
                        <span>Guardar cambios</span>
                      </button>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
